<template>
  <Fragment>
    <MiniHero image="https://assets.creekdog.org/pollution-on-deckers.jpg">
      <h1 class="py-2">Help keep Deckers Creek safe and clean</h1>
      <p>We need your help to maintain and improve Deckers Creek water quality. Due to the abundance of mining in the area, acid mine drainage is the most common pollutant. The illegal dumping of trash, construction waste, vehicle parts, and other items also pollute stream flow and disrupt wildlife habitats along the creek. </p>
      <router-link :to="{ name: 'reportPollution' }" class="btn btn-success btn-lg">
        Report Pollution
      </router-link>
    </MiniHero>
    <GmapMap id="pollution" ref="pollution" :center="center" :zoom="zoom" :options="options"/>
    <div class="cd_container py-5">
      <Issues />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import MiniHero from '../mini-hero'
import Issues from '../issues'
import { gmapApi } from 'gmap-vue'
import { BLUEWATER } from '@/constants/map-settings'

export default {
  name: 'Pollution',
  components: {
    Fragment,
    MiniHero,
    Issues
  },
  data (){
    return {
      zoom: 12,
      center: {lat: 39.563739804406154, lng: -79.84381050000002},
      kml: 'https://assets.creekdog.org/deckers-creek-watershed.kml',
      options: {styles: BLUEWATER},
    }
  },
  computed: {
    google: gmapApi
  },
  async mounted(){
    await this.$gmapApiPromiseLazy();
    this.$refs.pollution.$mapPromise.then((map) => {
      new this.google.maps.KmlLayer({
        url: 'https://assets.creekdog.org/deckers-creek-watershed.kml',
        preserveViewport: true,
        map: map
      })
    })
  }
}
</script>

<style>

#pollution {
  height: 600px;
}

</style>
